import { Injectable } from '@angular/core';
import { Http, Headers, Response, Jsonp, RequestOptions } from '@angular/http';
import { Configuration } from "app/shared/models/configuration";
import * as appGlobal from '../global/globals';


import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
// import 'rxjs/Rx';






@Injectable()
export class ConfigService {

  /* Variable to gold the configuration file into memory for use with other components */
  private configFile: Configuration;


  /* Constructor and dependency injection of the Http Service*/
  constructor(private http: Http) { }


  /*    Load the Configuration file from memory, if does not exists, call the Get Configuration */
  getConfiguration(): Configuration {
    if (this.configFile == null) {
      this.getApiConfiguration()
        .then(config => this.configFile = config,
      );
    }
    return this.configFile;
  }

  /*    Promise to load json file from URL -> (assets/config/config.json) -> this file must be in the wwwroot/assets/config*/
  private getApiConfiguration = (): Promise<Configuration> => {

    return this.http
      .get(appGlobal.configPath)
      .map((res: Response) => res.json())
      .toPromise()
      .then((data: Configuration) => this.configFile = data)
      .catch((err: any) => Promise.resolve());
  }


}



// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/shared/services/configuration/config.service.ts